var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "centered": "",
      "size": "md"
    },
    on: {
      "hidden": function ($event) {
        return _vm.$emit('update:isShow', false);
      }
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function () {
        return [_c('h4', {
          staticClass: "mb-0 text-primary"
        }, [_vm._v(" " + _vm._s(_vm.isViewOnly ? _vm.$t("ar_client_detail_sms") : _vm.$t("ar_client_update_sms")) + " ")]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_vm.isValidPermission(_vm.AR_USMS01) ? _c('ez-icon', {
          staticClass: "mr-1",
          class: {
            'cursor-pointer': _vm.isViewOnly
          },
          attrs: {
            "icon": "ezAr-icon-edit",
            "size": "24",
            "color": _vm.isViewOnly ? '#ea5455' : '#ccc'
          },
          on: {
            "click": function ($event) {
              _vm.isViewOnly = false;
            }
          }
        }) : _vm._e(), _c('ez-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "icon": "ezAr-icon-x",
            "size": "24",
            "color": "#114A9F"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('update:isShow', false);
            }
          }
        })], 1)];
      },
      proxy: true
    }, {
      key: "modal-footer",
      fn: function () {
        return [!_vm.isViewOnly && _vm.data.Status !== 'YES' ? _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.updateSMS
          }
        }, [_vm._v(_vm._s(_vm.$t("ar_common_save")))]) : _c('div')];
      },
      proxy: true
    }]),
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('FormItems', {
    ref: "formRef",
    attrs: {
      "disabled": _vm.data.Status === 'YES' || _vm.isViewOnly,
      "formData": _vm.formData,
      "items": _vm.formItems
    },
    on: {
      "update:formData": function ($event) {
        _vm.formData = $event;
      },
      "update:form-data": function ($event) {
        _vm.formData = $event;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }